
import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'secondary' | 'outline';
  className?: string;
}

const CustomBadge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'default',
  className = '',
}) => {
  const baseStyles = "inline-flex items-center rounded-full px-3 py-1 text-xs font-medium transition-all duration-300";
  
  const variantStyles = {
    default: "bg-astrem-black text-white",
    secondary: "bg-astrem-gray-100 text-astrem-gray-800",
    outline: "bg-transparent border border-astrem-gray-200 text-astrem-gray-700"
  };
  
  return (
    <span className={`${baseStyles} ${variantStyles[variant]} ${className}`}>
      {children}
    </span>
  );
};

export default CustomBadge;
